function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.83 6.483a1 1 0 01-1.66 0L.855 1.559A1 1 0 011.684 0h6.633a1 1 0 01.83 1.559L5.828 6.483z"
});
function SvgToggleGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#50A684"
  }, props), _ref);
}
export default SvgToggleGreen;